import { CmsDetailMember } from '../../../components/Cms';

export function Cms() {
  return <CmsDetailMember />;
}
